module.exports = __webpack_public_path__ + "img/pn_bg.e7632af7.jpg";